import * as yup from 'yup';
import { validationMessagesTranslation } from '../translation';

yup.setLocale(validationMessagesTranslation);

export const cnpjSchema = yup.string()
  .matches(/^[0-9]+$/)
  .length(14)
  .test('valid-cnpj', 'CNPJ inválido', (value) => {
    if (value?.length < 14) return true;
    let cnpj = value ?? '';
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj === '00000000000000'
    || cnpj === '11111111111111'
    || cnpj === '22222222222222'
    || cnpj === '33333333333333'
    || cnpj === '44444444444444'
    || cnpj === '55555555555555'
    || cnpj === '66666666666666'
    || cnpj === '77777777777777'
    || cnpj === '88888888888888'
    || cnpj === '99999999999999') return false;

    let length = cnpj.length - 2;
    let numbers = cnpj.substring(0, length);
    let sum = 0;
    let position = length - 7;

    const digits = cnpj.substring(length);

    for (let i = length; i >= 1; i -= 1) {
      sum += numbers.charAt(length - i) * position;
      position -= 1;

      if (position < 2) position = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result.toString() !== digits.charAt(0)) return false;


    length += 1;
    numbers = cnpj.substring(0, length);
    sum = 0;
    position = length - 7;
    for (let i = length; i >= 1; i -= 1) {
      sum += numbers.charAt(length - i) * position;
      position -= 1;

      if (position < 2) position = 9;
    }

    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result.toString() !== digits.charAt(1)) return false;

    return value;
  });


export const producerSchema = yup.object().shape({
  companyName: yup.string().min(3).required(),
  producerName: yup.string().min(3),
  cnpj: cnpjSchema.required(),
  stateRegister: yup.string().min(8).max(9),
});
